import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type {
  IApiInvitationLanguage,
  IApiInvitationOrganizationRole,
} from '~/lib/api/modules/Invitations';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useFormAutoFocus } from '~/hooks/useFormAutoFocus';
import { OrganizationInvitationFormMainSection } from './OrganizationInvitationFormMainSection';

export type IOrganizationInvitationFormValues = {
  organizationId?: string;
  email?: string;
  role?: IApiInvitationOrganizationRole;
  language?: IApiInvitationLanguage;
};

export type IOrganizationInvitationFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IOrganizationInvitationFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<IOrganizationInvitationFormValues>;
    onSubmit?: SubmitHandler<IOrganizationInvitationFormValues>;
  };

export const OrganizationInvitationForm: React.FC<
  IOrganizationInvitationFormProps
> = (props) => {
  const { sx, mode, defaultValues, onSubmit, ...other } = props;
  const form = useForm<IOrganizationInvitationFormValues>({
    defaultValues,
  });
  useFormAutoFocus({ form, name: 'email' });
  const { t } = useTranslation();

  return (
    <ContentBlock.FormBody
      sx={sx}
      form={form}
      onSubmit={onSubmit}
      submitButtonLabel={t('common.submit')}
      {...other}
    >
      <OrganizationInvitationFormMainSection form={form} mode={mode} />
    </ContentBlock.FormBody>
  );
};
